var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export const getWalletConnectUri = (connector, uriConverter) => __awaiter(void 0, void 0, void 0, function* () {
    const provider = yield connector.getProvider();
    if (connector.type === 'coinbaseWallet') {
        // @ts-expect-error
        return provider.qrUrl;
    }
    return new Promise(resolve => 
    // Wagmi v2 doesn't have a return type for provider yet
    // @ts-expect-error
    provider.once('display_uri', uri => {
        resolve(uriConverter ? uriConverter(uri) : uri);
    }));
});
